import React, { useState } from "react";
import ConfirmPasswordSection from "../../components/ResetPasswordSection/ConfirmPasswordSection";
import { confirmPassword } from "./logic/confirmPasswordHelper";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsLoading } from "../../features/userSlice";

const ConfirmPasswordScreen: React.FC = () => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [reNewPassword, setReNewPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [isSuccess, setIsSuccess] = useState(false);

  const dispatch = useDispatch();
  const { uid, token } = useParams<{ uid: string; token: string }>();

  // === handle typing in inputs ===
  const handleNewPasswordChange = (value: string) => {
    setNewPassword(value);
    setPasswordError(null); // clear error when typing
    if (!value && !reNewPassword) {
      setPasswordError(null);
    }
  };

  const handleReNewPasswordChange = (value: string) => {
    setReNewPassword(value);
    setPasswordError(null); // clear error when typing
    if (!value && !newPassword) {
      setPasswordError(null);
    }
  };

  // === handle reset password ===
  const handleResetPasswordConfirm = async () => {
    dispatch(setIsLoading(true));
    try {
      if (!uid || !token) {
        throw new Error("Invalid parameters for password confirmation");
      }

      // validation
      if (!newPassword || !reNewPassword) {
        setPasswordError("Please fill in both password fields.");
        return;
      }

      if (newPassword !== reNewPassword) {
        setPasswordError("The passwords you entered do not match.");
        return;
      }

      await confirmPassword(uid, token, newPassword, reNewPassword);
      setIsSuccess(true);

      // reset states
      setNewPassword("");
      setReNewPassword("");
      setPasswordError(null);
    } catch (error: any) {
      setSnackbarMessage(error.message || "Something went wrong");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <ConfirmPasswordSection
      newPassword={newPassword}
      reNewPassword={reNewPassword}
      passwordError={passwordError}
      showPassword={showPassword}
      onNewPasswordChange={handleNewPasswordChange}
      onReNewPasswordChange={handleReNewPasswordChange}
      onToggleShowPassword={handleClickShowPassword}
      onResetPasswordConfirm={handleResetPasswordConfirm}
      snackbarOpen={snackbarOpen}
      snackbarMessage={snackbarMessage}
      snackbarSeverity={snackbarSeverity}
      onSnackbarClose={handleSnackbarClose}
      isSuccess={isSuccess}
    />
  );
};

export default ConfirmPasswordScreen;
